import React, { useState, useEffect, useMemo } from 'react';
import './styles.css';
import Card from '../Card';
import "./styles.css";
import ItemList, { UiColumn, UiColumn2 } from '../ItemList/indexOld';
import axios from "axios";
import useAppData from '@/store/useAppData';
import { AgGridReact } from "ag-grid-react";
import { themeQuartz } from "ag-grid-community";
import useRouter from '@/store/useRouter';
import { useShallow } from "zustand/shallow";
import FloatingActions, { FloatingAction } from '../FloatingActions';
import { RouterStoreItemKey } from '@/store/useRouter/types';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faUser, faArrowLeft, faFloppyDisk, faPlus } from "@fortawesome/free-solid-svg-icons";
import { AG_GRID_LOCALE_CZ } from '@ag-grid-community/locale';
import NewInventoryCard from '../NewInventoryDeice';
import { exportItemsToTablePdf, TableColumn, urlToDataUrl } from '@/Utils/exportInventoryResultToPdf';
import { ExcelColumn, exportItemsToExcel } from '@/Utils/exportInventoryResultToExcel';
import logoAirlines from "../Login/logoAirlines.png";
import DialogWindow from '../DialogWindow';
import { StockItemTypeOdmraz, StockMovement } from '@/Utils/constants';
import { toLocalDateTimeOffset } from '../DeicingForm';
import { exportInventoryToExcel } from '@/Utils/exportInventoryDeiceToExcel';
import { exportInventoryToPdf } from '@/Utils/exportInventoryDeiceToPdf';

export interface InventoryItem {
    id: number;
    date?: string;
    stockId?: string;
    completed?: boolean;
    description?: string;
    createdBy?: string;
    checkedBy?: string;
}

interface Item {
    id: string;
    name: string;
    quantity_fluid_type1?: number;
    quantity_fluid_type2?: number;
    quantity_container?: number;
    remove?: boolean;
    constraints?: string | null;
}

const myTheme = themeQuartz.withParams({
    fontSize: 17,
    headerFontSize: 17,
    rowHeight: 55,
    headerHeight: 48,
});

const InventoryDeice = () => {

    const selectedStock = useAppData(state => state.selectedStock);

    const router = useRouter(
        useShallow(state => ({
            go: state.go,
            history: state.history
        }))
    );

    // const columnsPrintInventory: TableColumn<Item>[] = [
    //     { header: "Id", field: "id", widthMm: 18 },
    //     { header: "Název", field: "name", widthMm: 80 },
    //     { header: "Stav", field: "state", widthMm: 18 },
    //     { header: "Kolekce", field: "list1", widthMm: 22 },
    //     { header: "Pohlaví", field: "list2", widthMm: 18 },
    //     { header: "Velikost", field: "list3", widthMm: 18 },
    //     { header: "Zkontrolováno", field: "inventoryDate", widthMm: 28 },
    //     { header: "Aktuální", field: "quantity", widthMm: 16, align: "right" },
    //     { header: "Puvodní", field: "oldQuantity", widthMm: 16, align: "right" },
    //     { header: "Rozdíl", field: "diffQuantity", widthMm: 16, align: "right" }
    // ];

    // const columnsExcel = [
    //     { header: "Id", field: "id", width: 10, type: "text" },
    //     { header: "Název", field: "name", width: 35, type: "text" },
    //     { header: "Stav", field: "state", width: 12, type: "text" },
    //     { header: "Kolekce", field: "list1", width: 14, type: "text" },
    //     { header: "Pohlaví", field: "list2", width: 12, type: "text" },
    //     { header: "Velikost", field: "list3", width: 12, type: "text" },
    //     { header: "Inventura", field: "inventoryDate", width: 22, type: "date" },
    //     { header: "Počet", field: "quantity", width: 10, type: "number", align: "right" },
    //     { header: "Puvodní", field: "oldQuantity", width: 10, type: "number", align: "right" },
    //     { header: "Rozdíl", field: "diffQuantity", width: 10, type: "number", align: "right" }
    // ] satisfies readonly ExcelColumn<Item>[];

    const columns: UiColumn2<Item>[] = [
        // { field: "id", headerName: "Id", flex: 0.5, filter: 'agTextColumnFilter', floatingFilter: true },
        { field: "name", headerName: "Položka", flex: 3, filter: 'agTextColumnFilter', floatingFilter: true, editable: true },
        {
            field: "quantity_fluid_type1",
            headerName: "Počet kapalina typ I",
            flex: 1, filter: 'agTextColumnFilter',
            floatingFilter: true,
            editable: params => params.data?.constraints ? containsType(params.data?.constraints, "I") : true,
            cellStyle: params => editableCellStyle(params.data?.constraints ? containsType(params.data?.constraints, "I") : true),
        },
        {
            field: "quantity_fluid_type2",
            headerName: "Počet kapalina typ II",
            flex: 1,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            editable: params => params.data?.constraints ? containsType(params.data?.constraints, "II") : true,
            cellStyle: params => editableCellStyle(params.data?.constraints ? containsType(params.data?.constraints, "II") : true),
        },
        {
            field: "quantity_container",
            headerName: "Počet kusů",
            flex: 1,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            editable: params => params.data?.constraints ? containsType(params.data?.constraints, "KS") : true,
            cellStyle: params => editableCellStyle(params.data?.constraints ? containsType(params.data?.constraints, "KS") : true),
        },
        {
            headerName: "",
            field: "remove",
            flex: 1,
            minWidth: 140,
            cellRenderer: (params: any) => (
                <button
                    type="button"
                    className="inventory-check-btn"
                    onClick={async () => {

                        await removeItem(params.data.id);
                        await getInventories();
                        // await logic.updateInventoryDate(params.data.id);
                        // logic.getStockItems();
                        // logic.setFirstId(null);
                    }}
                >
                    Odebrat
                </button>
            ),
        },
    ]

    const [stocksItemsState, setStocksItemsState] = React.useState<Item[] | null>([]);
    const [firstIdState, setFirstId] = React.useState<string | null>(null);
    const [selectedInventoryState, setSelectedInventoryState] = React.useState<InventoryItem | null>(null);
    const selectedInventoryBuffer = React.useRef<InventoryItem | null>(null);
    const [inventoriesState, setInventoriesState] = React.useState<InventoryItem[]>([]);
    const [displayNewInventoryForm, setDisplayNewInventoryForm] = React.useState<boolean>(false);
    const [showFinishDialog, setShowFinishDialog] = useState(false);
    const [showNoCheckedItemsDialog, setShowNoCheckedItemsDialog] = useState(false);
    const [isFinishing, setIsFinishing] = useState(false);
    const gridApiRef = React.useRef(null);
    const colApiRef = React.useRef(null);
    const [showNotFinishedInventoryDialog, setShowNotFinishedInventoryDialog] = useState<boolean>(false);
    const [notFinishedInventoryText, setsNotFinishedInventoryText] = useState<string>("");
    const loggedUser = useAppData(state => state.user);
    const [fluidType1, setFluidType1] = React.useState<number>(0);
    const [fluidType2, setFluidType2] = React.useState<number>(0);
    const [containers, setContainers] = React.useState<number>(0);
    const [showCheckedInventoryDialogWindow, setShowCheckedInventoryDialogWindow] = useState(false);

    const columnsCompletedInventory: UiColumn2<Item>[] = [
        // { field: "id", headerName: "Id", flex: 0.5, filter: 'agTextColumnFilter', floatingFilter: true },
        { field: "name", headerName: "Položka", flex: 3, filter: 'agTextColumnFilter', floatingFilter: true },
        { field: "quantity_fluid_type1", headerName: "Počet kapalina typ I (litr)", flex: 1, filter: 'agTextColumnFilter', floatingFilter: true },
        { field: "quantity_fluid_type2", headerName: "Počet kapalina typ II (litr)", flex: 1, filter: 'agTextColumnFilter', floatingFilter: true },
        { field: "quantity_container", headerName: "IBC (Počet kusů)", flex: 1, filter: 'agTextColumnFilter', floatingFilter: true }
    ]

    const actions: FloatingAction[] = [
        {
            key: "3",
            label: "Zpět",
            icon: <FontAwesomeIcon icon={faArrowLeft} />,
            onClick: () => {
                // @ts-ignore
                gridApiRef.current?.stopEditing();
                router.go({ key: RouterStoreItemKey.LISTITEMS })
            },
        },
        ...(selectedInventoryBuffer?.current && !selectedInventoryBuffer?.current?.completed
            ? [
                {
                    key: "2",
                    label: "Přidat položku",
                    icon: <FontAwesomeIcon icon={faPlus} />,
                    onClick: () => onAddInventoryItem()
                },
                {
                    key: "1",
                    label: "Ukončit inventuru",
                    icon: <FontAwesomeIcon icon={faFloppyDisk} />,
                    onClick: () => {
                        // @ts-ignore
                        gridApiRef.current?.stopEditing();
                        onSave();
                    }
                },
            ]
            : []),
    ];

    const totalConsumptionQuantityContainer = useMemo(() => {
        let sum = 0;

        stocksItemsState?.forEach(stockItem => {
            sum += Number(stockItem?.quantity_container) || 0;
        });

        return sum;
    }, [stocksItemsState]);

    const totalConsumptionFluidType1 = useMemo(() => {
        let sum = 0;

        stocksItemsState?.forEach(stockItem => {
            sum += Number(stockItem?.quantity_fluid_type1) || 0;
        });

        return sum;
    }, [stocksItemsState]);

    const totalConsumptionFluidType2 = useMemo(() => {
        let sum = 0;

        stocksItemsState?.forEach(stockItem => {
            sum += Number(stockItem?.quantity_fluid_type2) || 0;
        });

        return sum;
    }, [stocksItemsState]);

    const containsType = (
        value: string | null | undefined,
        type: string
    ): boolean => {
        return value
            ?.split(",")
            .map(x => x.trim())
            .includes(type) ?? false;
    };

    const editableCellStyle = (editable: boolean) => {
        if (editable) {
            return {
                backgroundColor: "#fff",
                fontWeight: "600",
            };
        }

        return {
            backgroundColor: "#f3f3f3",
            color: "#888",
        };
    };

    const dateFormat = (date: string, dateOnly?: boolean) => {
        const d = new Date(date);

        const pad = (n: number) => String(n).padStart(2, "0");

        if (dateOnly) {
            return (
                pad(d.getDate()) + "." +
                pad(d.getMonth() + 1) + "." +
                d.getFullYear()
            );
        } else {
            return (
                pad(d.getDate()) + "." +
                pad(d.getMonth() + 1) + "." +
                d.getFullYear() + " " +
                pad(d.getHours()) + ":" +
                pad(d.getMinutes()) + ":" +
                pad(d.getSeconds())
            );
        }
    };

    useEffect(() => {
        const loadData = async () => {
            await getInventories();
            await loadActualStateMainStock();
        };

        loadData();
    }, []);

    useEffect(() => {

        if (selectedInventoryState?.id) {
            getInventoryItems(selectedInventoryState.id);
        }
    }, [selectedInventoryState]);

    const loadActualStateMainStock = async () => {
        const itemsMainStock = await getItemsMainStock();

        const itemMainStockFluidType1 = itemsMainStock.filter(item => item?.name === StockItemTypeOdmraz.Type1)[0];
        const itemMainStockFluidType2 = itemsMainStock.filter(item => item?.name === StockItemTypeOdmraz.Type2)[0];
        const itemMainStockContainer = itemsMainStock.filter(item => item?.name === StockItemTypeOdmraz.Container)[0];

        setFluidType1(itemMainStockFluidType1?.quantity || 0);
        setFluidType2(itemMainStockFluidType2?.quantity || 0);
        setContainers(itemMainStockContainer?.quantity || 0);
    }

    // useEffect(() => {
    //     const loadData = async () => {
    //         if (selectedInventoryBuffer.current?.id) {
    //             await getStockItems();
    //         }
    //     };

    //     loadData();
    // }, [selectedInventoryBuffer.current]);

    // useEffect(() => {
    //     if (!firstIdState) return;

    //     const t = setTimeout(() => {
    //         requestAnimationFrame(() => {
    //             focusAndEditById(firstIdState, "quantity");
    //         });
    //     }, 50);

    //     return () => clearTimeout(t);
    // }, [firstIdState]);

    const onAddInventoryItem = async () => {
        if (selectedInventoryState?.id) {
            await insertInventoryItem(selectedInventoryState?.id);
            await getInventoryItems(selectedInventoryState?.id);
        }
    }

    const getInventoryItems = async (inventoryId: number) => {
        try {
            const res = await (
                axios({
                    method: "post",
                    url: "/api/inventorydeice/getItems",
                    data: {
                        inventoryId: inventoryId
                    }
                })
            );

            setStocksItemsState(res.data.inventoryItems);
        } catch (err) {
            console.log(err);
            throw err;
        }
    }

    const getInventories = async () => {
        try {
            const res = await (
                axios({
                    method: "post",
                    url: "/api/inventorydeice/getAll",
                })
            );

            if (res.data.inventory && res.data.inventory.length > 0) {
                setInventoriesState(res.data.inventory);
                selectedInventoryBuffer.current = res.data.inventory[0];
                setSelectedInventoryState(res.data.inventory[0]);
                return res.data.inventory;
            } else {
                setInventoriesState([]);
                selectedInventoryBuffer.current = null;
                return [];
            }
        } catch (err) {
            console.log(err);
            throw err;
        }
    }

    const updateItemName = async (id: string, name: string) => {
        try {
            const res = await axios({
                method: "post",
                url: "/api/inventorydeice/updateItem",
                data: {
                    inventory_item_id: id,
                    name: name
                },
            });

            return res.data.id;
        } catch (err) {
            console.error("Failed to update inventory deice item", err);
            throw err;
        }
    };

    const updateQuantityFluidType1 = async (id: string, quantity: string) => {
        try {
            const res = await axios({
                method: "post",
                url: "/api/inventorydeice/updateItem",
                data: {
                    inventory_item_id: id,
                    quantityFluidType1: quantity
                },
            });

            return res.data.id;
        } catch (err) {
            console.error("Failed to update inventory deice item", err);
            throw err;
        }
    };

    const updateQuantityFluidType2 = async (id: string, quantity: string) => {
        try {
            const res = await axios({
                method: "post",
                url: "/api/inventorydeice/updateItem",
                data: {
                    inventory_item_id: id,
                    quantityFluidType2: quantity
                },
            });

            return res.data.id;
        } catch (err) {
            console.error("Failed to update inventory deice item", err);
            throw err;
        }
    };

    const updateQuantityContainer = async (id: string, quantity: string) => {
        try {
            const res = await axios({
                method: "post",
                url: "/api/inventorydeice/updateItem",
                data: {
                    inventory_item_id: id,
                    quantityContainer: quantity
                },
            });

            return res.data.id;
        } catch (err) {
            console.error("Failed to update inventory deice item", err);
            throw err;
        }
    };

    const insertInventoryItem = async (inventoryId: number) => {
        try {
            const res = await axios({
                method: "post",
                url: "/api/inventorydeice/insertItem",
                data: {
                    inventoryId: inventoryId
                },
            });

            return res.data.id;
        } catch (err) {
            console.error("Failed to update inventory deice item", err);
            throw err;
        }
    };

    const updateInventory = async (inventoryId: number, completed?: boolean, checkedBy?: string) => {
        try {
            const res = await axios({
                method: "post",
                url: "/api/inventorydeice/update",
                data: {
                    inventoryId: inventoryId,
                    completed: completed,
                    checkedBy: checkedBy
                },
            });

            return res.data.id;
        } catch (err) {
            console.error("Failed to update inventory item", err);
            throw err;
        }
    };

    const getItemsMainStock = async () => {
        try {
            const res = await (
                axios({
                    method: "post",
                    url: "api/inventorydeice/getItemsMainStock"
                })
            );

            return res.data.stockitems;
        } catch (err) {
            console.log(err);
            throw err;
        }
    }

    const updateQauntity = async (id: string, quantity: number) => {
        try {

            const res = await axios({
                method: "post",
                url: "/api/stockitem/updateQuantity",
                data: {
                    id: id,
                    quantity: quantity
                },
            });

            return res.data.id;
        } catch (err) {
            console.error("Failed to update stock item", err);
            throw err;
        }
    };

    const stockMovement = async (stockId: string, stockItemId: string, stockMovementId: string, quantity: number, userId: string, inventory: boolean) => {
        try {
            const res = await axios({
                method: "post",
                url: "/api/log/stockMoveOdmraz",
                data: {
                    stockId: stockId,
                    stockItemId: stockItemId,
                    quantity: quantity,
                    stockMovementId: stockMovementId,
                    userId: userId,
                    inventory: inventory,
                    date: toLocalDateTimeOffset(new Date())
                },
            });

            return res.data.id;
        } catch (err) {
            console.error("Failed to make stock movement item", err);
            throw err;
        }
    };


    const removeItem = async (id: string) => {
        try {
            await axios({
                method: "post",
                url: "/api/inventorydeice/removeItem",
                data: {
                    id: id
                },
            });
        } catch (err) {
            console.error("Failed to remove inventory deice item", err);
            throw err;
        }
    }


    // const updateInventoryDate2 = async (inventoryId: number) => {
    //     try {
    //         const res = await axios({
    //             method: "post",
    //             url: "/api/inventory/updateInventoryDate2",
    //             data: {
    //                 inventoryId: inventoryId
    //             },
    //         });

    //         return res.data.id;
    //     } catch (err) {
    //         console.error("Failed to update inventory item", err);
    //         throw err;
    //     }
    // };

    // const updateInventorySetCompleted = async (inventoryId: string, completed: boolean) => {
    //     try {
    //         const res = await axios({
    //             method: "post",
    //             url: "/api/inventory/setCompleted",
    //             data: {
    //                 id: inventoryId,
    //                 completed: completed
    //             },
    //         });

    //         return res.data.id;
    //     } catch (err) {
    //         console.error("Failed to update inventory item", err);
    //         throw err;
    //     }
    // };

    const handleCellValueChanged = async (params: any) => {
        const { colDef, data, oldValue, newValue, value } = {
            colDef: params.colDef,
            data: params.data,
            oldValue: params.oldValue,
            newValue: params.newValue,
            value: params.value,
        };

        if (colDef.field === 'quantity_fluid_type1') {

            if (newValue) {
                await updateQuantityFluidType1(data.id, newValue);

                setStocksItemsState(prev =>
                    prev?.map(item =>
                        item.id === data.id
                            ? {
                                ...item,
                                quantity_fluid_type1: Number(newValue) || 0
                            }
                            : item
                    ) ?? []
                );
            }
        } else if (colDef.field === 'quantity_fluid_type2') {
            if (newValue) {
                await updateQuantityFluidType2(data.id, newValue);

                setStocksItemsState(prev =>
                    prev?.map(item =>
                        item.id === data.id
                            ? {
                                ...item,
                                quantity_fluid_type2: Number(newValue) || 0
                            }
                            : item
                    ) ?? []
                );
            }
        } else if (colDef.field === 'name') {
            if (newValue) {
                await updateItemName(data.id, newValue);

                setStocksItemsState(prev =>
                    prev?.map(item =>
                        item.id === data.id
                            ? { ...item, name: newValue }
                            : item
                    ) ?? []
                );
            }
        } else if (colDef.field === 'quantity_container') {
            if (newValue) {
                await updateQuantityContainer(data.id, newValue);

                setStocksItemsState(prev =>
                    prev?.map(item =>
                        item.id === data.id
                            ? { ...item, quantity_container: Number(newValue) || 0 }
                            : item
                    ) ?? []
                );
            }
        }
    };

    const onSave = async () => {

        if (selectedInventoryBuffer.current?.id) {

            const itemsMainStock = await getItemsMainStock();

            const itemMainStockFluidType1 = itemsMainStock.filter(item => item?.name === StockItemTypeOdmraz.Type1)[0];
            const itemMainStockFluidType2 = itemsMainStock.filter(item => item?.name === StockItemTypeOdmraz.Type2)[0];
            const itemMainStockContainer = itemsMainStock.filter(item => item?.name === StockItemTypeOdmraz.Container)[0];

            let sumFluidType1 = 0;
            let sumFluidType2 = 0;
            let sumContainer = 0;

            stocksItemsState?.forEach(stockItem => {
                sumFluidType1 += Number(stockItem?.quantity_fluid_type1) || 0;
                sumFluidType2 += Number(stockItem?.quantity_fluid_type2) || 0;
                sumContainer += Number(stockItem?.quantity_container) || 0;
            });

            updateQauntity(itemMainStockFluidType1.id, sumFluidType1);
            updateQauntity(itemMainStockFluidType2.id, sumFluidType2);
            updateQauntity(itemMainStockContainer.id, sumContainer);

            await updateInventory(selectedInventoryBuffer.current?.id, true);

            await stockMovement(itemMainStockFluidType1.stockId, itemMainStockFluidType1.id, String(StockMovement.StockIn), sumFluidType1, loggedUser?.id!, true);
            await stockMovement(itemMainStockFluidType2.stockId, itemMainStockFluidType2.id, String(StockMovement.StockIn), sumFluidType2, loggedUser?.id!, true);

            await getInventories();

            // await updateInventoryDate2(selectedInventoryBuffer.current?.id);
            // await updateInventoryQuantityToStockItems(selectedInventoryBuffer.current?.id);
            // const updateInventoryId = await updateInventorySetCompleted(String(selectedInventoryBuffer.current?.id/*selectedInventoryState?.id*/), true);
            // const newInventories = await getInventories(selectedStock?.id);
            // const selectedInventory = newInventories.filter(inventory => inventory.id == Number(updateInventoryId))[0];
            // selectedInventoryBuffer.current = selectedInventory;
            // setSelectedInventoryState(selectedInventory);
            // getStockItems();
        }
    }

    const onClickNewInventory = () => {
        const notCompletedInventories = inventoriesState.filter(inventory => inventory.completed === false);
        if (notCompletedInventories.length > 0) {
            const notCompletedInventory = notCompletedInventories[0];
            setsNotFinishedInventoryText(`Existuje nedokončená inventura: ${notCompletedInventory.description} (${dateFormat(notCompletedInventory.date, true)})`);
            setShowNotFinishedInventoryDialog(true);
        } else {
            setDisplayNewInventoryForm(true);
        }
    };

    // const onClickPrintInventory = async () => {

    //     if (selectedInventoryBuffer.current && selectedInventoryBuffer.current?.completed && stocksItemsState) {
    //         const stockItemsToPrint = stocksItemsState
    //             .filter(stockItem => !(stockItem.quantity === 0 && stockItem.oldQuantity === 0 && !stockItem.inventoryDate))
    //             .map(stockItem => ({
    //                 ...stockItem,
    //                 name: stripDiacritics(stockItem?.name),
    //             }));

    //         const logoBase64 = await urlToDataUrl(logoAirlines);

    //         exportItemsToTablePdf<Item>(stockItemsToPrint, columnsPrintInventory, {
    //             title: selectedInventoryBuffer.current?.description ? `${selectedInventoryBuffer.current?.description} (${dateFormat(selectedInventoryBuffer.current?.date, true)})` : "Inventura",
    //             fileName: `${selectedInventoryBuffer.current?.description ? `${dateFormat(selectedInventoryBuffer.current?.date, true)} ${selectedInventoryBuffer.current?.description}` : "Inventura"}.pdf`,
    //             fontSize: 9,
    //             logoDataUrl: logoBase64,
    //             logoFormat: "PNG",
    //             logoWidthMm: 30,
    //             logoHeightMm: 20,
    //             userName: "Admin"
    //         });
    //     }
    // };

    // const onClickPrintExcelInventory = async () => {

    //     if (selectedInventoryBuffer.current && selectedInventoryBuffer.current?.completed && stocksItemsState) {
    //         const stockItemsToPrint = stocksItemsState
    //             .filter(stockItem => !(stockItem.quantity === 0 && stockItem.oldQuantity === 0 && !stockItem.inventoryDate))
    //             .map(stockItem => ({
    //                 ...stockItem,
    //                 name: stripDiacritics(stockItem?.name),
    //             }));

    //         const logoBase64 = await urlToDataUrl(logoAirlines);
    //         await exportItemsToExcel<Item>(stockItemsToPrint, columnsExcel, {
    //             title: selectedInventoryBuffer.current?.description ? `${selectedInventoryBuffer.current?.description} (${dateFormat(selectedInventoryBuffer.current?.date, true)})` : "Inventura",
    //             fileName: `${selectedInventoryBuffer.current?.description ? `${dateFormat(selectedInventoryBuffer.current?.date, true)} ${selectedInventoryBuffer.current?.description}` : "Inventura"}.xlsx`,
    //             sheetName: selectedInventoryBuffer.current?.description ? `${selectedInventoryBuffer.current?.description} (${dateFormat(selectedInventoryBuffer.current?.date, true)})` : "Inventura",
    //             logoBase64,
    //             logoExt: "png",
    //             userName: "Admin"
    //         });
    //     }
    // };

    // const onClickPrintNotCheckedExcelInventory = async () => {

    //     if (selectedInventoryBuffer.current && !selectedInventoryBuffer.current?.completed && stocksItemsState) {
    //         const stockItemsToPrint = stocksItemsState
    //             .filter(stockItem =>  stockItem.oldQuantity > 0 && !stockItem.inventoryDate)
    //             .map(stockItem => ({
    //                 ...stockItem,
    //                 name: stripDiacritics(stockItem?.name),
    //             }));

    //         await exportItemsToExcel<Item>(stockItemsToPrint, columnsExcel, {
    //             title: selectedInventoryBuffer.current?.description ? `${selectedInventoryBuffer.current?.description} (${dateFormat(selectedInventoryBuffer.current?.date, true)}) Nezkontrolované položky` : "Inventura_Nezkontrolované_Položky",
    //             fileName: `${selectedInventoryBuffer.current?.description ? `${dateFormat(selectedInventoryBuffer.current?.date, true)}_${selectedInventoryBuffer.current?.description}__Nezkontrolované_Položky` : "Inventura_Nezkontrolované_Položky"}.xlsx`,
    //             sheetName: selectedInventoryBuffer.current?.description ? `${selectedInventoryBuffer.current?.description} (${dateFormat(selectedInventoryBuffer.current?.date, true)}) Nezkontrolované položky` : "Inventura_Nezkontrolované_Položky"
    //         });
    //     }
    // };

    // function stripDiacritics(text: string) {
    //     return text
    //         .normalize("NFD")
    //         .replace(/[\u0300-\u036f]/g, "");
    // }

    const onSaveNewInventory = async (newInventoryId: string) => {
        console.log("New inventory150");
        console.log(newInventoryId);

        setDisplayNewInventoryForm(false);
        const newInventories = await getInventories();

        if (newInventoryId) {
            const newInventory = newInventories.filter(inventory => inventory.id == Number(newInventoryId))[0];
            selectedInventoryBuffer.current = newInventory;
            setSelectedInventoryState(newInventory);
        } else {

            if (newInventories.length > 0) {
                const newInventory = newInventories[0];
                selectedInventoryBuffer.current = newInventory;
                setSelectedInventoryState(newInventory);
            } else {
                selectedInventoryBuffer.current = null;
                setSelectedInventoryState(null);
            }
        }
    };

    // const updateInventoryQuantityToStockItems = async (inventoryId: number) => {
    //     try {
    //         const res = await axios({
    //             method: "post",
    //             url: "/api/inventory/applyInventoryToStock",
    //             data: {
    //                 inventoryId: inventoryId
    //             },
    //         });

    //         return res.data?.ok;
    //     } catch (err) {
    //         console.error("Failed to update applyInventoryToStockItems", err);
    //         throw err;
    //     }
    // };

    const onGridReady = (params) => {
        gridApiRef.current = params.api;
        colApiRef.current = params.columnApi;
    };

    const onClickPrintExcelInventory = async () => {

        if (selectedInventoryBuffer.current && selectedInventoryBuffer.current?.completed && stocksItemsState) {
            const stockItemsToPrint = stocksItemsState
                .map(stockItem => ({
                    ...stockItem,
                    name: stripDiacritics(stockItem?.name),
                }));

            //const logoBase64 = await urlToDataUrl(logoAirlines);
            exportInventoryToExcel(stockItemsToPrint, {
                date: new Date(selectedInventoryBuffer.current?.date!),
                performedBy: selectedInventoryBuffer.current?.createdBy ?? "",
                checkedBy: selectedInventoryBuffer.current?.checkedBy ?? "",
                fileName: `${selectedInventoryBuffer.current?.description ? `${dateFormat(selectedInventoryBuffer.current?.date as any, true)} ${selectedInventoryBuffer.current?.description}` : "Inventura"}.xlsx`
            });
        }
    };

    const onClickPrintPdfInventory = async () => {

        if (
            selectedInventoryBuffer.current &&
            selectedInventoryBuffer.current.completed &&
            stocksItemsState
        ) {
            await exportInventoryToPdf(stocksItemsState, {
                date: new Date(
                    selectedInventoryBuffer.current.date!
                ),
                performedBy:
                    selectedInventoryBuffer.current.createdBy ?? "",
                checkedBy: selectedInventoryBuffer.current?.checkedBy ?? "",
                fileName: selectedInventoryBuffer.current.description
                    ? `${dateFormat(
                        selectedInventoryBuffer.current.date as any,
                        true
                    )} ${selectedInventoryBuffer.current.description}.pdf`
                    : "Inventura.pdf",
            });
        }
    };

    const onClickCheckInventory = async () => {
        await updateInventory(selectedInventoryBuffer.current?.id!, selectedInventoryBuffer.current?.completed, loggedUser?.id);
        setShowCheckedInventoryDialogWindow(true);
    }

    function stripDiacritics(text: string) {
        return text ? text
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "") : "";
    }

    // function focusAndEditById(rowId, colKey) {
    //     const api = gridApiRef.current;
    //     if (!api) return;

    //     const node = api.getRowNode(String(rowId));
    //     if (!node) return;

    //     const rowIndex = 0;

    //     api.setFocusedCell(rowIndex, colKey);
    //     api.startEditingCell({ rowIndex, colKey });
    // }

    return (displayNewInventoryForm ? (
        <NewInventoryCard onSave={onSaveNewInventory} inventoryId={selectedInventoryState?.id}></NewInventoryCard>
    ) : (<>
        {showNotFinishedInventoryDialog &&
            <DialogWindow
                displayDialog={showNotFinishedInventoryDialog}
                setDisplayDialog={setShowNotFinishedInventoryDialog}
                title={notFinishedInventoryText}
                cancelText={"OK"}
            />
        }
        {showFinishDialog && (
            <div className="inv-modal-overlay" onMouseDown={() => setShowFinishDialog(false)}>
                <div
                    className="inv-modal"
                    onMouseDown={(e) => e.stopPropagation()}
                    role="dialog"
                    aria-modal="true"
                >
                    <div className="inv-modal-title">Opravdu si přejete dokončit inventuru?</div>

                    <div className="inv-modal-actions1">
                        <button
                            type="button"
                            className="inv-btn"
                            disabled={isFinishing}
                            onClick={async () => {
                                setShowFinishDialog(false);
                                await onSave();
                            }}
                        >
                            Ano
                        </button>

                        <button
                            type="button"
                            className="inv-btn"
                            disabled={isFinishing}
                            onClick={() => setShowFinishDialog(false)}
                        >
                            Ne
                        </button>
                    </div>
                </div>
            </div>
        )}

        {showCheckedInventoryDialogWindow &&
            <DialogWindow
                displayDialog={showCheckedInventoryDialogWindow}
                setDisplayDialog={setShowCheckedInventoryDialogWindow}
                title={"Kontrola provedena."}
                cancelText={"OK"}
            />
        }
        {/* {showNoCheckedItemsDialog && (
            <div className="inv-modal-overlay" onMouseDown={() => setShowNoCheckedItemsDialog(false)}>
                <div
                    className="inv-modal"
                    onMouseDown={(e) => e.stopPropagation()}
                    role="dialog"
                    aria-modal="true"
                >
                    <div className="inv-modal-title">Byly zjištěny položky, které by měly být skladem, ale nebyly zkontrolovány. Přejete si přesto pokračovat?</div>

                    <div className="inv-modal-actions">
                        <div className="inv-modal-actions-left">
                            <button
                                type="button"
                                className="inv-btn"
                                onClick={onClickPrintNotCheckedExcelInventory}
                            >
                                Nezkontrolované položky (Excel)
                            </button>
                        </div>

                        <div className="inv-modal-actions-right">
                            <button
                                type="button"
                                className="inv-btn"
                                disabled={isFinishing}
                                onClick={async () => {
                                    setShowNoCheckedItemsDialog(false);
                                    await onSave();
                                }}
                            >
                                Ano
                            </button>

                            <button
                                type="button"
                                className="inv-btn"
                                disabled={isFinishing}
                                onClick={() => setShowNoCheckedItemsDialog(false)}
                            >
                                Ne
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )} */}
        <Card
            title="Inventura"
        >
            <div className="inventory-toolbar">
                <div className="inventory-toolbar-left">
                    <select className="inventory-select"
                        value={selectedInventoryBuffer.current?.id}
                        onChange={(e) => {

                            const selectedInventory = inventoriesState.filter(inventoryItem => inventoryItem.id == Number(e.target.value));
                            if (selectedInventory.length > 0) {
                                selectedInventoryBuffer.current = selectedInventory[0];
                                setSelectedInventoryState(selectedInventory[0]);
                            } else {
                                selectedInventoryBuffer.current = null
                                setSelectedInventoryState(null);
                                setStocksItemsState([]);
                            }
                        }}
                    >
                        <option value="">Vyberte inventuru</option>
                        {inventoriesState.map(inventory => <option value={inventory.id}>{`${dateFormat(inventory.date, true)} ${inventory.description}`}</option>)}
                    </select>

                    {selectedInventoryBuffer.current && selectedInventoryBuffer.current?.completed && <span className="inventory-status inventory-status--done">
                        Dokončeno
                    </span>}

                    {selectedInventoryBuffer.current && !selectedInventoryBuffer.current.completed && <span className="inventory-status inventory-status--undone">
                        Nedokončeno
                    </span>}

                    {(loggedUser?.userrole === "backoffice" || loggedUser?.userrole === "admin") &&
                        <button
                            type="button"
                            className="inventory-new-btn"
                            onClick={onClickCheckInventory}
                        >
                            Kontrola
                        </button>}

                </div>

                <div className="inventory-toolbar-right">

                    {selectedInventoryBuffer.current && selectedInventoryBuffer.current?.completed &&
                        <button
                            type="button"
                            className="inventory-new-btn"
                            onClick={onClickPrintPdfInventory}
                        >
                            PDF
                        </button>}

                    {selectedInventoryBuffer.current && selectedInventoryBuffer.current?.completed &&
                        <button
                            type="button"
                            className="inventory-new-btn"
                            onClick={onClickPrintExcelInventory}
                        >
                            Excel
                        </button>}

                    <button
                        type="button"
                        className="inventory-new-btn"
                        onClick={onClickNewInventory}
                    >
                        Nová inventura
                    </button>
                </div>
            </div>
            <div className="item-list-grid-wrapper">
                <AgGridReact
                    theme={myTheme}
                    columnDefs={selectedInventoryBuffer.current && selectedInventoryBuffer.current?.completed ? columnsCompletedInventory : columns}
                    rowData={stocksItemsState}
                    onCellValueChanged={handleCellValueChanged}
                    pagination={false}
                    getRowId={(params) => String(params.data.id)}
                    // getRowStyle={(params) => {
                    //     if (firstIdState && params.data?.id == firstIdState) {
                    //         return {
                    //             backgroundColor: "#ffe680"
                    //         };
                    //     }

                    //     return null;
                    // }}
                    localeText={AG_GRID_LOCALE_CZ}
                    onGridReady={onGridReady}
                // enterNavigatesVertically={false}
                // enterNavigatesVerticallyAfterEdit={false}
                />
            </div>
            <div className="stockGrid__footer">
                <span className="stockGrid__total">
                    Hlavní sklad kapalina I / II: <b>{fluidType1}</b> / <b>{fluidType2}</b> | Inventura kapalina I / II: <b>{totalConsumptionFluidType1}</b> / <b>{totalConsumptionFluidType2}</b> | IBC (Počet kusů): <b>{containers}</b> / <b>{totalConsumptionQuantityContainer}</b>
                </span>
            </div>

            {
                actions?.length ? (
                    <div className="item-list-actions">
                        <FloatingActions actions={actions} />
                    </div>
                ) : null
            }
        </Card ></>));
};

export default InventoryDeice;